export class SignatureType {

    id: number = 0;
    code!: string;
    description!: string;
    active: boolean = false;
}